<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="Username"
          rules="required"
        >
          <input-field
            name="ez_drm-username"
            :error="errors.length ? errors[0] : null"
            label="Username *"
            label-position="top"
          >
            <b-form-input
              id="ez_drm-username"
              v-model="settings.username"
              :state="errors.length > 0 ? false:null"
              placeholder="Enter username..."
            />
          </input-field>
        </validation-provider>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="Password"
          rules="required"
        >
          <input-field
            name="ez_drm-password"
            label="Password *"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-input
              id="ez_drm-password"
              v-model="settings.password"
              :state="errors.length > 0 ? false:null"
              placeholder="Enter password..."
              type="password"
            />
          </input-field>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import InputField from '@/components/form/InputField.vue'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'EzDrm',
  components: {
    InputField,
    ValidationProvider,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },

}
</script>

<style>

</style>
